module.exports = __webpack_public_path__ + "static/img/dialog-prize-item.0f4650e9.png";